export const enum PreviewModeLabelPosition {
    InsideTopLeft = 0,
    OutsideLeft = 1,
    OutsideRight = 2,
}